var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStream(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 193.4 49.3",
    style: {
      enableBackground: "new 0 0 193.4 49.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M5.7,35.7c0,5.7,4.5,9.4,11.5,9.4c7.1,0,12-3.6,12-9.3c0-4.5-2.5-6.8-7.6-8l-5.3-1.3c-2.9-0.7-4.4-2.1-4.4-4.1 c0-2.8,2-4.3,5.6-4.3c3.5,0,5.5,1.9,5.6,4.9h5.5c-0.1-5.7-4.4-9.4-10.9-9.4c-6.6,0-11.2,3.5-11.2,9c0,4.4,2.5,7,7.8,8.3l5.3,1.2 c3.1,0.8,4.1,2,4.1,4c0,2.8-2.3,4.4-6.4,4.4c-3.8,0-6.1-1.8-6.1-4.9H5.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M44,44.4V19.3h5.9v-4.8H44V5.1h-5.7v9.4h-5.9v4.8h5.9v25.1H44z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M72.2,14.2c-1.2-0.2-2-0.4-3.1-0.4c-4.1,0-7.1,2.1-8.3,5.2l-0.4-4.5H55v29.8h5.7V28.6c0-5.7,3.4-9.1,8.8-9.1 h2.6V14.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M89.4,45.1c7.4,0,12.4-3.6,13.9-10h-5.4c-1,3.4-3.9,5.3-8.4,5.3c-5.7,0-9-3.5-9.4-9.8l23.1-0.1v-2.1 c0-8.9-5.6-14.7-14.1-14.7c-8.7,0-14.6,6.5-14.6,15.8C74.5,38.8,80.6,45.1,89.4,45.1z M89.1,18.5c5.1,0,8.3,3.3,8.3,8.3H80.2 C80.9,21.5,84.1,18.5,89.1,18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M118,45.1c4.8,0,8.9-2.1,10.5-5.6l0.6,4.8h4.9V25.6c0-8.1-5-12-12.4-12c-7.7,0-12.8,4.1-12.8,10.3h5 c0-3.6,2.8-5.7,7.6-5.7c4,0,7,1.8,7,6.8v0.9l-9.4,0.7c-7,0.6-11.1,4-11.1,9.5C107.8,41.5,111.6,45.1,118,45.1z M119.7,40.7 c-3.7,0-6.1-1.6-6.1-4.8c0-2.9,2.1-4.9,7.2-5.4l7.6-0.6v1.6C128.4,37.1,125.1,40.7,119.7,40.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M147.7,26.7v17.7H142V14.5h5.1l0.6,3.9c1-1.9,2.8-3.4,5.1-4.2v4.9C149.6,20,147.7,22.7,147.7,26.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M161.8,22.8c0-4.7-2.6-7.3-6.8-7.3c-0.8,0-1.6,0.1-2.3,0.3v-5c1.2-0.4,2.5-0.6,4-0.6c3.5,0,6.2,1.2,8,3.3 c0.7,0.8,1.3,1.7,1.7,2.8c1.4-3.8,5.2-6.1,9.9-6.1c7.1,0,11.3,4.3,11.3,11.3v19.7h-5.8V22.8c0-4.7-2.7-7.5-6.9-7.5 c-4.5,0-7.4,3.1-7.4,7.9v17.9h-2.9h-2.9V22.8z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStream);
export default __webpack_public_path__ + "static/media/Stream.1cde2ffbf0de840f21968a9a3f28f01d.svg";
export { ForwardRef as ReactComponent };